import api from '@/lib/api';
import { withBuScope } from '@/lib/business-unit-scope';
import { API_ENDPOINTS } from '@/constants/endpoints';
import type { ApiResponse } from '@/types';
import type { WorkflowTemplate } from '@/modules/workflows/types';

export const workflowTemplateService = {
  async getTemplates(): Promise<WorkflowTemplate[]> {
    const response = await api.get<ApiResponse<WorkflowTemplate[]>>(API_ENDPOINTS.WORKFLOW_TEMPLATES.BASE);
    return response.data.data;
  },

  async getTemplateById(id: string): Promise<WorkflowTemplate> {
    const response = await api.get<ApiResponse<WorkflowTemplate>>(API_ENDPOINTS.WORKFLOW_TEMPLATES.BY_ID(id));
    return response.data.data;
  },

  /**
   * Templates are account-wide; the WORKFLOW made from one belongs to a brand.
   *
   * The backend does two things with this scope - it stamps the new workflow and it picks
   * which channels to enable on it - so omitting it silently produces a shared workflow
   * wired to the account's channels rather than the brand's.
   */
  async useTemplate(
    id: string,
    name?: string,
    buScope: { bu_id?: string } = {},
  ): Promise<{ id: string; name: string }> {
    const response = await api.post<ApiResponse<{ id: string; name: string }>>(
      withBuScope(API_ENDPOINTS.WORKFLOW_TEMPLATES.USE(id), buScope),
      name ? { name } : {},
    );
    return response.data.data;
  },
};
